import { Component, OnInit } from '@angular/core';
import { AuthResult } from '../auth.result';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../auth.service';
import { NavigationService } from '@common/services/utility/navigation.service';
import { SpecialistsService } from '@common/services/specialist/specialists.service';

@Component({
  selector: 'app-auth-sso-component',
  templateUrl: './auth-sso.component.html',
})
export class AuthSsoComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private navigationService: NavigationService,
    private specialistsService: SpecialistsService,
  ) {}

  public async ngOnInit(): Promise<void> {
    const token = this.activatedRoute.snapshot.queryParamMap.get('token');
    const refreshToken = this.activatedRoute.snapshot.queryParamMap.get('refreshToken');
    if (!token) {
      return;
    }

    const authResult = await this.authService.apiAuthorizeByCCToken(token, refreshToken);
    if (authResult !== AuthResult.Success) {
      return;
    }

    await this.navigationService.navigateToMainForUserPage(this.specialistsService.specialist);
  }
}
